var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsKnockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9H5.5M19.5 9H22.5V15H19.5M19.5 9V5C19.5 3.89543 18.6046 3 17.5 3H3.5C2.39543 3 1.5 3.89543 1.5 5V9H5.5M19.5 15H5.5M19.5 15V19C19.5 20.1046 18.6046 21 17.5 21H3.5C2.39543 21 1.5 20.1046 1.5 19V15H5.5M5.5 9V15",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsKnockout);
export default __webpack_public_path__ + "static/media/groups-knockout.8dabbf65a0a7f060eccea28a1719277e.svg";
export { ForwardRef as ReactComponent };